import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import expertRessourcesPostureDuFormateurStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'expertRessourcesPostureDuFormateur'
const customImplement: CustomStoreImplementationOptions = expertRessourcesPostureDuFormateurStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function expertRessourcesPostureDuFormateurFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('expert-ressource-5-posture-formateur.title', 'Posture de l\'expert, formateur occasionnel '),
        $description: $translate('expert-ressource-5-posture-formateur.description', 'Vous faites vos premiers pas en tant que formateur occasionnel et vous vous demandez quelle posture adopter ? Lors d\'une formation Matchers l\'expert n\'est ni consultant, ni mentor, ni coach. L\'expert est véritablement FORMATEUR. Découvrez la posture à adopter pour être 100% à l\'aise dans cette nouvelle expérience, LA FORMATION ! '),
        $publishedTime: new Date('2023-08-01T13:10:04.774Z'),
        $modifiedTime: new Date('2023-09-07T09:03:13.405Z'),
        // Constants,
        $constants: {
          k4EtapesTxtHidden: false,
          k4EtapesTxtHidden1: null
        },
        // Data,
        $info: { expertRessource5PostureFormateur: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async toutesLesRessourcesClick () {
        await navigateTo({ name: 'hub-expert-Ressources' })
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevUpClick () {
        this.$elements['k-4-etapes-txt'].style = { hidden: this.$constants.k4EtapesTxtHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      iconeDevUpClickWhenSelected () {
        this.$elements['k-4-etapes-txt'].style = { hidden: this.$constants.k4EtapesTxtHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container12Click () { },
      /* @ts-ignore: to allow override in your custom file */
      async element1Click () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element2Click () {
        await navigateTo({ name: 'hub-expert-Ressources-preparer-rdv-decouverte' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element3Click () {
        await navigateTo({ name: 'hub-expert-Ressources-rediger-programme-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return expertRessourcesPostureDuFormateurFactory(storeId)()
}

export const expertRessourcesPostureDuFormateurRaw = expertRessourcesPostureDuFormateurFactory()
export const expertRessourcesPostureDuFormateur = () => expertRessourcesPostureDuFormateurRaw() as MergeCustomStore<typeof expertRessourcesPostureDuFormateurStoreCustom.instance>
